/**
 * 올린 파일 → **소품 이름·키**.
 *
 * 운영자가 하려는 일은 "폴더에서 그림 고르기"다. 이름을 따로 묻지 않고 **파일 이름에서**
 * 만든다(`바위.png` → "바위"). 고치고 싶으면 고칠 수 있게 화면에 보여 준다.
 *
 * 키는 [➕ 직접 만들기]와 **같은 규칙**이라 양쪽 목록에 같이 나타난다.
 */

/** 파일 이름 → 사람이 읽는 소품 이름. 확장자·경로·군더더기를 걷어낸다. */
export function propNameFromFileName(fileName: string): string {
  const base = fileName.split(/[\\/]/).pop() ?? fileName; // 폴더 경로가 붙어 오는 경우
  const noExt = base.replace(/\.[a-z0-9]+$/i, "");
  // 파일 관리용 군더더기: 앞 번호(01_), 끝 번호(-1, _2), 공백/밑줄/하이픈 정리
  const cleaned = noExt
    .replace(/^\d{1,3}[-_. ]+/, "")
    .replace(/[-_]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  return (cleaned || noExt || "소품").slice(0, 20);
}

/** 한글 이름 → 안전한 id. 영숫자가 있으면 그걸, 없으면(한글만) 안정적인 짧은 해시. */
export function propIdFromName(title: string): string {
  const ascii = title.toLowerCase().replace(/[^a-z0-9_]/g, "").slice(0, 20);
  if (ascii) return ascii;
  let h = 0;
  for (let i = 0; i < title.length; i++) h = (h * 31 + title.charCodeAt(i)) >>> 0;
  return "p" + h.toString(36);
}

/**
 * 이름 → 매니페스트 키. **이미 있으면 뒤에 번호를 붙인다**(덮어쓰지 않는다).
 *
 * 여러 장을 한 번에 올릴 때 같은 이름이 섞이기 쉽고, 덮어쓰면 **먼저 올린 그림이 말없이
 * 사라진다** — 어느 오브젝트가 그 그림을 쓰고 있었는지 알 방법이 없다.
 */
export function propKeyFor(name: string, takenKeys: readonly string[]): string {
  const base = `decor.${propIdFromName(name)}`;
  if (!takenKeys.includes(base)) return base;
  for (let n = 2; n < 1000; n++) {
    const k = `${base}${n}`;
    if (!takenKeys.includes(k)) return k;
  }
  return `${base}_${Date.now()}`;
}
